import React from 'react';
import ProductsHero from '../components/ProductsHero/ProductsHero';
import ProductModuleContent from '../components/ProductModuleContent/ProductModuleContent';
import ProductModulePricing from '../components/ProductModulePricing/ProductModulePricing';
import './Products.css';

const SIX_BOXES = [
  {
    title: 'Topic-based discussions',
    description: 'Start conversations by topic so decisions, questions, and updates stay easy to find later.',
  },
  {
    title: 'Keep the context',
    description: 'Replies, files, and follow-ups live with the original discussion instead of disappearing in chat.',
  },
  {
    title: 'Notify the right people',
    description: 'Bring in the team members who need to weigh in without copying the whole company.',
  },
  {
    title: 'Share files and updates',
    description: 'Attach documents and keep the latest information next to the conversation that needs it.',
  },
  {
    title: 'Search past conversations',
    description: 'Find earlier decisions and discussions quickly instead of scrolling through old threads.',
  },
  {
    title: 'Move work forward',
    description: 'Turn discussion outcomes into tasks so talk becomes action without leaving flowdo.',
  },
];

const FEATURES = [
  'Start topic-based discussions',
  'Share files and updates',
  'Keep context with replies',
  'Notify the right people',
  'Search past conversations easily',
  'Favorite important threads',
  'Track discussion history',
  'Link conversations to tasks',
];

const ProductsForum = () => (
  <div className="products-page">
    <ProductsHero title="Discussion Forum" bannerSection="Products > Discussion Forum">
      <p className="text-muted">
        In any organization, there are decisions that are taken based on several rounds of discussions. In most
        situations, only the decision is finally noted and remembered, but the approach that lead to the decision
        is forgotten. flowdo Discussion Forum helps you create a forum of relevant team members and
        record/communicate all the details related to the particular topic. Minutes of the meeting, suggestions,
        comments, and even online communication on these topics can be carried out in Discussion Forum.
      </p>
      <p className="text-muted">
        Create tasks from a comment or reply, assigning only the relevant team members, with all relevant data
        auto populated. This helps in managing a task based on an ongoing discussion, allowing to track the
        progress as well as speed up decision making.
      </p>
    </ProductsHero>
    <ProductModuleContent
      sixBoxes={SIX_BOXES}
      features={FEATURES}
    />
    <ProductModulePricing
      moduleKey="discussion_forum"
      moduleLabel="Discussion Forum"
      registerModule="forum"
    />
  </div>
);

export default ProductsForum;
